import { createSlice } from "@reduxjs/toolkit";
import { FunnelState } from "#app/store/types/funnel";

const initialState: FunnelState = {
    servicesMap: { values: [] },
    clientsMap: { values: [] },
    starsMap: { values: [] },
    filledData: [],
    clientsData: [],
    minDate: null,
    maxDate: null,
    loading: false,
    error: null,
};

export const funnelSlice = createSlice({
    name: "funnel",
    initialState,
    reducers: {
        funnelDataRequested(state) {
            state.loading = true;
            state.error = null;
        },
        funnelDataReceived(state, action) {
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        },
        funnelDataError(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        },
    },
});

export const { funnelDataRequested, funnelDataReceived, funnelDataError } = funnelSlice.actions;

export default funnelSlice.reducer;
